// MT wishlist heart toggle. Delegated click handler so it works on hearts
// rendered later (e.g. inside a collection grid that re-renders on filter).
(function () {
  // Anchors the toast just above the tapped heart (fixed-position, tracks
  // current scroll position) instead of a generic bottom-of-page toast the
  // user has to look away from the thing they just tapped to find.
  function showToast(message, anchorEl) {
    var toast = document.createElement('div');
    toast.textContent = message;
    toast.setAttribute('role', 'status');
    toast.style.cssText =
      'position:fixed; background:#241a0d; color:#fffdf8; font-family:Georgia,serif; font-size:13px;' +
      'padding:10px 16px; border-radius:6px; z-index:9999; opacity:0; transition:opacity .18s ease, transform .18s ease;' +
      'box-shadow:0 6px 20px rgba(0,0,0,.25); max-width:220px; text-align:center; pointer-events:none;';
    document.body.appendChild(toast);

    if (anchorEl) {
      var rect = anchorEl.getBoundingClientRect();
      var toastRect = toast.getBoundingClientRect();
      var left = rect.left + rect.width / 2 - toastRect.width / 2;
      left = Math.max(8, Math.min(left, window.innerWidth - toastRect.width - 8));
      var top = rect.top - toastRect.height - 10;
      var settledTop = top;
      var startTop = top + 6;
      if (top < 8) {
        settledTop = rect.bottom + 10;
        startTop = settledTop - 6;
      }
      toast.style.left = left + 'px';
      toast.style.top = startTop + 'px';
      toast.style.transform = 'translateY(0)';
      requestAnimationFrame(function () {
        toast.style.opacity = '1';
        toast.style.top = settledTop + 'px';
      });
    } else {
      toast.style.left = '50%';
      toast.style.bottom = '28px';
      toast.style.transform = 'translateX(-50%) translateY(10px)';
      requestAnimationFrame(function () {
        toast.style.opacity = '1';
        toast.style.transform = 'translateX(-50%) translateY(0)';
      });
    }

    setTimeout(function () {
      toast.style.opacity = '0';
      setTimeout(function () { toast.remove(); }, 250);
    }, 2000);
  }

  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-mt-wishlist-heart]');
    if (!btn) return;
    e.preventDefault();

    if (btn.dataset.loggedIn !== 'true') {
      showToast('Sign in to save items to your wishlist', btn);
      window.location.href = btn.dataset.loginUrl;
      return;
    }

    if (btn.disabled) return;
    var wasActive = btn.classList.contains('is-active');
    var action = wasActive ? 'remove' : 'add';

    btn.disabled = true;
    btn.classList.toggle('is-active', !wasActive);
    btn.setAttribute('aria-pressed', String(!wasActive));
    btn.setAttribute('title', !wasActive ? 'Remove from wishlist' : 'Add to wishlist');
    btn.setAttribute('aria-label', !wasActive ? 'Remove from wishlist' : 'Add to wishlist');

    try {
      var res = await fetch('/apps/wishlist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ productId: btn.dataset.productId, action: action }),
      });
      if (!res.ok) throw new Error('wishlist request failed: ' + res.status);
      showToast(action === 'add' ? 'Added to your wishlist' : 'Removed from your wishlist', btn);
    } catch (err) {
      btn.classList.toggle('is-active', wasActive);
      btn.setAttribute('aria-pressed', String(wasActive));
      showToast('Something went wrong, please try again', btn);
      console.error('[mt-wishlist]', err);
    } finally {
      btn.disabled = false;
    }
  });

  // Hover tooltip for sighted desktop users, mirrors the aria-label.
  document.addEventListener(
    'mouseover',
    function (e) {
      var btn = e.target.closest('[data-mt-wishlist-heart]');
      if (btn && !btn.getAttribute('title')) {
        btn.setAttribute('title', btn.classList.contains('is-active') ? 'Remove from wishlist' : 'Add to wishlist');
      }
    },
    true
  );
})();
